import { CART_UPDATED_EVENT, getCartCount } from './cartStore.ts';

/** Tient à jour le badge de comptage sur l'icône panier du header (présente sur toutes les pages publiques). */
export function initCartBadge(): void {
  const badge = document.getElementById('cart-badge');
  if (!badge) return;

  function render(count: number): void {
    badge!.textContent = String(count);
    badge!.hidden = count === 0;
  }

  render(getCartCount());
  window.addEventListener(CART_UPDATED_EVENT, (e) => {
    render((e as CustomEvent<{ count: number }>).detail.count);
  });
}
